module.exports = __webpack_public_path__ + "static/img/200126.d63a8cdf.png";